export default __webpack_public_path__ + "static/media/8.b5813356.png";